<template lang="pug">
  server-data(
    ref="serverData"
    v-model="items"
    :query="query"
    :method="method"
    :serialize-data="(resp) => resp.items"
    :no-init="noInit"
    :start-loading-value="!noInit"
    :search-field-name="`search[${itemText}]`"
    @data:received="onDataReceived"
    v-slot="{ selectProps, loadMoreItems, search }"
  )
    dv-autocomplete(
      v-bind="{ ...selectProps, ...$attrs, ...autocompleteProps }"
      v-on="$listeners"
      :items="serializedItems"
      no-filter
      @update:search-input="(val) => onSearchInput({ val, search })"
    )
      template(
        v-for="(_, name) in $scopedSlots"
        v-slot:[name]="data"
      )
        slot(:name="name" v-bind="data")
      template(
        v-for="(_, name) in $slots"
        :slot="name"
      )
        slot(:name="name")

      template(v-slot:append-item)
        div(v-intersect="(val) => onIntersect(val, { loadMoreItems })")
        slot(name="append-item")
</template>

<script>
import DvAutocomplete from './DvAutocomplete.vue';
import get from 'lodash/get';

export default {
  components:  {
    DvAutocomplete,
  },
  props: {
    method: {
      type: Function,
      required: true,
    },
    itemText: {
      type: String,
      default: 'name',
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    serializeItems: {
      type: Function,
      default: (items) => items,
    },
    noInit: {
      type: Boolean,
      default: false,
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    serializedItems() {
      const { items } = this;
      return this.serializeItems(items);
    },
    autocompleteProps() {
      const { itemText, itemValue } = this;
      return {
        'item-text': itemText,
        itemText,
        'item-value': itemValue,
        itemValue,
      };
    },
  },
  methods: {
    onIntersect([{ isIntersecting }], { loadMoreItems }) {
      if (isIntersecting) loadMoreItems();
    },
    onDataReceived(val) {
      this.$emit('data:received', val);
    },
    onSearchInput({ val, search }) {
      const { serializedItems, itemText } = this;

      if (serializedItems.some((item) => {
        if (typeof item === 'object') {
          return get(item, itemText) === val;
        }

        return item === val;
      })) return;

      search(val);
    },
    updateItems(items = []) {
      const newItems = items.reduce((acc, item) => {
        const itemIndex = acc.findIndex((i) => i.id === item.id);

        if (itemIndex !== -1) {
          acc[itemIndex] = item;
          return acc;
        }

        return [...acc, item];
      }, [...this.$refs.serverData?.serverData || []]);

      this.$refs.serverData.updateServerData(newItems);
    },
  },
};
</script>
